import { Settings } from "../../settings/settings";
import { Message } from "../message";
import { SprayAndWait } from "../spray.and.wait";
import { Abacus } from "./abacus";

export class DensityAwareSprayAndWait extends SprayAndWait {

    numCopiesToBeSent: number = this.settings.DEFAULT_MESSAGE_COPIES;

    abaci: Array<Abacus> = [];

    constructor(nodeID: string, settings: Settings) {
        super(nodeID, settings);

        this.createAbaci();
    }

    receiveMessages(messages: Array<Message>) {
        super.receiveMessages(messages);

        messages.forEach((message: Message) => {
            if(message.timeTakenToArrive != undefined) {
                message.abacus?.addData(message.timeTakenToArrive);
            } 
        });
    }

    createAbaci() {
        this.settings.ABACI_TO_CREATE.numCopies.forEach((numCopies: number) => {
            this.settings.ABACI_TO_CREATE.avgNodeDegree.forEach((avgNodeDegree: number) => {
                this.abaci.push(new Abacus(this.settings, avgNodeDegree, numCopies));
            });
        });
    }

    getDesiredAbacus(desiredAvgNodeDegree: number, desiredDelay: number): Abacus {
        // find the most relevant abacus and send back their numCopies

        let closestDesiredDelay = this.abaci[0].getAvgDelay();
        let closestAvgNodeDegree = this.abaci[0].nodeDegree;

        this.abaci.forEach((abacus: Abacus) => {
            if(Math.abs(abacus.nodeDegree - desiredAvgNodeDegree) < Math.abs(desiredAvgNodeDegree - closestAvgNodeDegree)) {
                closestAvgNodeDegree = abacus.nodeDegree;
            }            
        });

        let abaciWithCorrectNodeDegree = this.abaci.filter((abacus: Abacus) => abacus.nodeDegree == closestAvgNodeDegree);

        abaciWithCorrectNodeDegree.forEach((abacus: Abacus) => {
            if(Math.abs(abacus.getAvgDelay() - desiredDelay) < Math.abs(desiredDelay - closestDesiredDelay)) {
                closestDesiredDelay = abacus.getAvgDelay();
            }
        });

        // find abacus wirh correct numbers
        let abacusResult: Abacus = abaciWithCorrectNodeDegree.find((abacus: Abacus) => 
            abacus.getAvgDelay() == closestDesiredDelay && abacus.nodeDegree == closestAvgNodeDegree
        ) ?? abaciWithCorrectNodeDegree[0];

        return abacusResult;
    }

}